import type { TaskWithRelations } from '@vagusx/clients';
import { pickActionDrawer } from './action-drawers/registry';

interface NextStepSectionProps {
  task: TaskWithRelations;
}

/**
 * "Your next step" card — pulls the headline + button(s) from whichever
 * action drawer the registry matches for this task. Renders nothing
 * when no drawer matches, so non-actionable tasks (e.g. info-only) don't
 * grow an empty card.
 */
export function NextStepSection({ task }: NextStepSectionProps): React.ReactElement | null {
  const drawer = pickActionDrawer(task);
  if (!drawer) return null;

  return (
    <section className="rounded-lg border bg-card p-4">
      <div className="text-xs font-semibold uppercase tracking-wide text-muted-foreground">
        Your next step
      </div>
      <h3 className="mt-1 text-base font-semibold leading-snug">{drawer.headline}</h3>
      <div className="mt-3 flex flex-wrap items-center gap-2">{drawer.render(task)}</div>
    </section>
  );
}
